/**
 * Route for `opinion-universe-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OpinionUniverseIntegrationPage } from "../features/opinion-universe-integration/OpinionUniverseIntegrationPage";

export const opinionUniverseIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/opinion-universe-integration",
	component: OpinionUniverseIntegrationPage,
});

export default opinionUniverseIntegrationRoute;
